// extracted by css-extract-rspack-plugin
export default {"cls1":"PaywallPage-cls1_Zm8","cls2":"PaywallPage-cls2_8Ce PaywallPage-cls1_Zm8"};